'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AddTitle = require('./components/AddTitle.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AddTitle).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/add-title/lib/components/add-title/index.js
// module id = 974
// module chunks = 1